"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = exports.presets = void 0;
var react_1 = __importDefault(require("react"));
exports.presets = {
    short: {
        focusTime: 10 * 60,
        breakTime: 2 * 60,
        cycles: 8,
    },
    standard: {
        focusTime: 25 * 60,
        breakTime: 5 * 60,
        cycles: 4,
    },
    long: {
        focusTime: 50 * 60,
        breakTime: 10 * 60,
        cycles: 2,
    },
};
exports.defaultValue = {
    breakTime: exports.presets.standard.breakTime,
    clear: function () { return null; },
    closePopover: function () { return null; },
    cycle: 1,
    cycles: exports.presets.standard.cycles,
    enablePreset: function () { return null; },
    focusTime: exports.presets.standard.focusTime,
    message: 'none',
    mode: 'inactive',
    openPopover: function () { return null; },
    pause: function () { return null; },
    paused: true,
    studyMode: false,
    popoverOpen: false,
    play: function () { return null; },
    playFocusAlertSound: function () { return null; },
    presets: exports.presets,
    progress: 0,
    remainingTime: exports.presets.standard.focusTime,
    reset: function () { return null; },
    setBreakTime: function () { return null; },
    setCycles: function () { return null; },
    setFocusTime: function () { return null; },
    setStudyModeEnabled: function () { return null; },
    soundEnabled: true,
    usingPreset: false,
};
exports.default = react_1.default.createContext(exports.defaultValue);
//# sourceMappingURL=pomodoroContext.js.map